import { useNavigate } from "react-router-dom";
import { Store, Package } from "lucide-react";
import { ServiceCard } from "@/components/ServiceCard";
import { useLang } from "@/context/LangContext";
import { HomeSection, HomeSectionHeader } from "@/components/home/HomeSection";

/** Two premium action cards — find a supplier / used marketplace. */
export function HomeServiceChooser() {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <HomeSection tone="white" testId="home-service-chooser">
      <HomeSectionHeader
        kicker={t("services.kicker")}
        title={t("services.chooser_title")}
        subtitle={t("services.subtitle")}
      />

      <div
        className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6"
        data-testid="service-chooser"
      >
        <ServiceCard
          icon={Store}
          title={t("services.suppliers_title")}
          description={t("services.suppliers_desc")}
          cta={t("services.suppliers_cta")}
          onSelect={() => navigate("/fournisseurs", { state: { fromServiceChooser: true } })}
          testId="service-card-suppliers"
        />
        <ServiceCard
          icon={Package}
          title={t("services.marketplace_title")}
          description={t("services.marketplace_desc")}
          cta={t("services.marketplace_cta")}
          onSelect={() => navigate("/recherche", { state: { fromServiceChooser: true } })}
          testId="service-card-marketplace"
        />
      </div>
    </HomeSection>
  );
}
